import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initRuntimeConfig } from "@/app/bootstrap/initRuntimeConfig";
import { AppProviders } from "@/app/providers/AppProviders";
import App from "@/App";
import "@/styles/index.css";

/* pdf.js (~970 KB) and mammoth (~940 KB) used to be imported here and attached
 * to window at startup, putting ~1.9 MB on the critical path of every page —
 * including login, which uses neither. They now load on first use via
 * ensurePdfjs() / ensureMammoth(). */
initRuntimeConfig();

/* Opt-in interview diagnostics (see Interview.tsx, grep DBG-b7c1): remember a
 * ?dbg=... switch from the landing URL so the interview screen can read it after
 * client-side navigation has dropped the query string. Off unless present. */
try {
  const dbg = new URLSearchParams(window.location.search).get("dbg");
  if (dbg != null) sessionStorage.setItem("dbg_b7c1", dbg);
} catch {
  /* storage blocked — flags simply won't persist */
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>,
);
